import React from 'react';
import { CircularProgress } from 'src/components';

/**
 * TableLoadingIndicator - renders a loading indicator in the center of the table
 * @param {string} height - height of the table
 * @returns {JSX.Element}
 */

interface TableLoadingIndicatorProps {
  top?: string | number;
}

const TableLoadingIndicator = ({
  top = 0,
}: TableLoadingIndicatorProps) => {
  return (
    <div
      data-testid="loading-indicator"
      style={{
        position: 'absolute',
        top: top,
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: 2,
        width: '100%',
        background: 'rgba(97, 97, 97, 0.1)',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <CircularProgress color="neutral" size="sm" />
      </div>
    </div>
  );
};

export default TableLoadingIndicator;
